<template>
    <div>
<!--        <van-nav-bar-->
<!--                title="公司简介"-->
<!--                left-text=""-->
<!--                left-arrow-->
<!--                fixed-->
<!--                @click-left="back()"-->
<!--                v-if="show"-->
<!--        />-->

        <div class="searchwarp">

            <div class="van-cell-group van-hairline--top-bottom van-panel" style="border-bottom: 0">
<!--                <div class="van-cell van-panel__header">-->
<!--                    <div class="van-cell__title">-->
<!--                        <span>天津市瑞和仓储有限公司简介</span>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="van-panel__content" style="line-height: 1.8">
                    <div>
                        <P style="text-indent:2em;text-align:justify;">
                            天津市瑞和仓储有限公司为天津市新兴伟业集装箱装卸服务有限公司旗下子公司，主要负责有色金属业务非交割业务，是华北地区最大的有色金属物流仓储企业。企业前身“天津市港瑞 商贸储运有限公司”，企业秉承“客户至上、服务第一”的发展理 念。坚持“专业、专一、专心”的企业宗旨，顽强拼搏，积极进取，脚踏实地干事创业，连续十年被“天津口岸管理委员会”评委“五好仓库”较好的企业信誉，赢得了用户的信赖，为企业良性健康发展，做大做强奠定了坚实的基础。
                        </P>
                        <p><img src="../../assets/image/aboutuspic2.jpg" width="100%"/></p>
                        <P style="text-indent:2em;text-align:justify;">
                            天津市瑞和仓储有限公司地处天津空港加工区和天津自贸区内，交通便利四通八达，是最适于有色金属物流和仓储的最佳 地域。仓库占地面积 24 万平方米，封闭库房五座 2 万平方米， 后期规划 2 万平方米，拥有铁路专用线一条，可同时停靠 50 节 车皮或集装箱一列，铁路专用线货场 4 万平方米，并具有专业、 规范、训练有素的专业接卸队伍。龙门吊、汽车吊、叉车、集装 箱专用靠背等各种专业设备及器具齐全有效。仓库库容量达 20 万吨，年出库各种有色金属 90 万吨，并拥有 2000 平方米的商务 中心及完善的监控设施，是仓储运输、期货交割、质押、融资的 理想场所。2013 年至 2015 年仓库有色金属吞吐量分别为 58 万 吨、64 万吨和 78 万吨。天津市瑞和仓储有限公司与三十多家国
                            内外及跨国大型企业建立了稳定的合作关系，与国内近100家金属生产及贸易企业保持长期合作，有色金属网络覆盖华北地区，在业内具有很高的知名度。同时，为客户提供小金属、铁合金等 商品的储存服务。天津市瑞和仓储有限公司，拥有一支素质高、业务精、作风扎实的管理团队，操作流程科学、严谨、规范，工作作风雷厉风行，视诚信为企业之本，以千方百计满足客户需求为天职，始终践行“一切为了客户、为了客户一切”的忠实誓言。
                        </P>
                        <p><img src="../../assets/image/aboutuspic1.jpg" width="100%"/></p>
                        <P style="text-indent:2em;text-align:justify;">
                            与此同时，仓库建立健全了《仓储管理制度》《安全管理制 度》《出入库管理制度》《安全生产现场管理规范》和《恶劣天气 灾害事件应急预案》，从制度入手，严格制度的执行程序，杜绝了一切可能发生的差错，严谨科学的管理，“专业、专一、专心” 的企业宗旨，科学务实的管理手段，使企业不断发展，客户满意 率日益攀升。天津市瑞和仓储有限公司正以创新发展的理念，以国家战略的视野，以精细化、程序化、标准化的要求，全面提升企业管理水平，全新打造社会化知名企业，为实现中国梦而不断的努力着。
                        </P>
                    </div>

                </div>
            </div>



        </div>

<!--        <van-row gutter="20" style="margin-top:10px">-->
<!--            <van-col span="8" offset="8">-->
<!--                <van-button block size="small" plain type="info" native-type="submit" class="button"-->
<!--                            @click="back()">-->
<!--                    关闭-->
<!--                </van-button>-->
<!--            </van-col>-->
<!--        </van-row>-->







    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                show: true,//nav bar
                list: [],
                loading: true,
                finished: false,
                searchValue: {},
                showPickerNotifySta: false,
                selProcessNotifyStatus: '',
                selProcessName: '',
                showPickerPro: false,
                selMachineName: '',
                showPickerMac: false,
                selMachineDetailName: '',
                showPickerMacD: false,
                selProcesstaskStatus: '',
                showPickerProSta: false,
                date: '',
                processData: [],
                processCol: [],
                machineData: [],
                machineCol: [],
                machineDetailData: [],
                machineDetailCol: [],
                addShowPop: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                taskCount: 0,
                sumWeight: 0,
                notifyCount: 0,
                //详情pop
                detailPop: false,
                detailList: [],
                packageDetailPop:false,
                productDetailPop:false,
                packageList: [],
                packageNo:[]
            }
        },
        mounted() {
            this.onLoad();
            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            service.selProcessG(parm).then(res => {
                let data = res.data;
                this.processData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.processCol.push(data[i].processName)
                }
            })
            service.selMachineNameG(parm).then(res => {
                let data = res.data;
                this.machineData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.machineCol.push(data[i].machineName)
                }
            })
        },

        methods: {
            formatDate(date) {
                return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            onConfirm(date) {
                this.show = false;
                this.date = this.formatDate(date);
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
            },

            onSearch() {
                this.list = [];
                this.page = 1;
                this.show = true;
                this.addShowPop = false;
                this.onLoad();
            },
            onLoad() {
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                setTimeout(() => {
                    for (let i = 0; i < 10; i++) {
                        this.list.push(this.list.length + 1);
                    }

                    // 加载状态结束
                    this.loading = false;

                    // 数据全部加载完成
                    if (this.list.length >= 40) {
                        this.finished = true;
                    }
                }, 1000);
            },
            getDetailList() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = this.page;
                searchObj.size = this.pageSize;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")
                service.selJgProcessnotify(JSON.parse(JSON.stringify(searchObj))).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                })
            },




        }
    }
</script>

<style scoped>


    .searchwarp {
        margin-top: 0px;
        height: calc(100vh - 5px);
        overflow: auto;
    }

    /*/deep/ .van-cell__title {*/
    /*    text-align: left;*/
    /*    -webkit-box-flex: unset;*/
    /*    -webkit-flex: unset;*/
    /*    flex: unset;*/
    /*}*/
    .van-panel__content{
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }
    .searchwarp .van-hairline--top-bottom::after {
        border-width:0;
    }
</style>
